module.exports = __webpack_public_path__ + "assets/img/NB.f2ab3bca.svg";